import Component from "../classes/Component"
import each from 'lodash/each'
// import "lightgallery.js"
import lightGallery from 'lightgallery';

import { app } from '../utils/store'

export default class LightBox{
    constructor({element}){
        this.element = element,
        this.elements = {
            images: element.querySelectorAll('img'),
        }

        this.create(this.element)
    }
    
    create = (entry) => {
        // console.log(entry)

        this.lighbox = lightGallery(entry, {
            licenseKey:	"0000-0000-000-0000",
            selector: 'img',
            closeOnTap: true,
            mousewheel: true,
            keypress: true,
            controls: false,
            download: false,
            counter: true,
            enableDrag: false,
            enableTouch: false,
            enableSwipe: true,
            subHtml: false,
            useLeft: true,
            hideControlOnEnd: true,
        })

        entry.addEventListener('lgBeforeOpen', () => {
            app.root?.classList.add('lg-materials')
        })

        entry.addEventListener('lgAfterClose', () => {
            app.root?.classList.remove('lg-materials')
        })
    }
}
